<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at  | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('fares.details.starts_at') }}</label></td>
      <td>{{ details.starts_at  | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('fares.details.ends_at') }}</label></td>
      <td v-if="details.ends_at">{{ details.ends_at | time }}</td>
      <td v-else>-</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.description') }}</label></td>
      <td>{{ details.description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.discountID') }}</label></td>
      <td>{{ details.discount_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('fares.details.fare_group_id') }}</label></td>
      <td>{{ details.fare_group_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('fares.details.municipality_id') }}</label></td>
      <td>{{ details.municipality_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('fares.details.pricing') }}</label></td>
      <td><meta-data-details :data="details.pricing"/></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by  }}</td>
    </tr>
  </table>
</template>
<script>

import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: 'fareDetails',
  components: {MetaDataDetails},
  props: {
    details: {
      type: Object,
      required: true,
    }
  },
  computed: {}
};
</script>
<style></style>
